const CARD_OFFER_ROUTE = 'card-offer';
const TEST_CARD_OFFER_ROUTE = 'credit-card-offer-apply-now';

export const ADS_SDK_ROUTES = [
  CARD_OFFER_ROUTE,
  TEST_CARD_OFFER_ROUTE,
];

export function isMastercardPage(route) {
  return ADS_SDK_ROUTES.includes(route.toLowerCase());
}
